
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'UIBulletedList',
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
});
